import { css } from 'aphrodite';
import * as React from 'react';
import KitIndicatorIconUrl from '../../../assets/icon_keepintouch.svg';
import { styleSheet } from './styles';

export const KeepInTouchAvatarWrapper = ({ children }: { children: React.ReactNode }) => {
	return (
		<div className={css(styleSheet.container)}>
			{children}
			<img className={`avatar-kit-imge ${css(styleSheet.avatarKit)}`} src={KitIndicatorIconUrl} />
		</div>
	);
};
